// Desc: Page to display the list of spreadsheets
// Updated: 29/08/2025

// React imports
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Material-UI imports
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

// Fuctions and Components to project
import EmptyTemplate from "../../assets/ilustrations/EmptyTemplates.png"
import HeaderPage from '../../components/HeaderPage/HeaderPage';
import ThemeColors from "../../components/ThemeColors/ThemeColors";
import Titles from "../../components/Titles/Titles";

import { DeleteListagens } from "../../api/aws/Listagens/DeleteListagens";
import { GetListagens } from "../../api/aws/Listagens/GetListagens";
import { isAuthenticated } from '../../authMiddleware';
import { truncateText } from "../../utils/utils";
import ModalR from "../../components/Modals/ModalR";
import use123zapStore from "../../context/123zapStore";
import { consultRegisteredIntegrations } from "../../api/aws/Integrations/listRegisteredIntegrations";
import SheetsTable from "../../components/Tables/SheetsTable";
import StatusIcon from "../../components/StatusLabel/StatusIcon";
import { GridViewStreamIcon } from "@mui/x-data-grid";
import DeleteIcon from "../../assets/Icons/components/Delete";
import StatusLabel from "../../components/StatusLabel/StatusLabel";
import themeColors from "../../components/ThemeColors/ThemeColors";

function Sheets() {

  // States to contro authetication and user info
  const userAuthenticated = use123zapStore((state) => state.userAuthenticated);
  const userInfo = use123zapStore((state) => state.userInfo);
  const setUserInfo = use123zapStore((state) => state.setUserInfo);
  const sheets = use123zapStore((state) => state.sheets);
  const setSheets = use123zapStore((state) => state.setSheets);
  const alreadyFetchSheets = use123zapStore((state) => state.alreadyFetchSheets);
  const setAlreadyFetchSheets = use123zapStore((state) => state.setAlreadyFetchSheets);
  const setRegisteredERPS = use123zapStore((state) => state.setRegisteredERPS);
  const alreadyFetchRegisteredERPS = use123zapStore((state) => state.alreadyFetchRegisteredERPS);
  const setAlreadyFetchRegisteredERPS = use123zapStore((state) => state.setAlreadyFetchRegisteredERPS);
  let navigate = useNavigate();

  // States to page control
  const [loading, setLoading] = useState(alreadyFetchSheets === false ? true : false);
  const [videoUrl, setVideoUrl] = useState("./listagens.mp4");
  const [openModalHelp, setOpenModalHelp] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [selectedList, setSelectedList] = useState(null);

  useEffect(() => {
    if (userAuthenticated && Object.keys(userInfo).length === 0) {
      const { decryptedData } = isAuthenticated();
      setUserInfo(decryptedData);
    }
  }, []);

  useEffect(() => {
    if (userInfo['UUID'] && alreadyFetchSheets === false) {
      fetchData();

    }

  }, [userInfo]);

  useEffect(() => {
    if (userInfo['UUID'] && alreadyFetchRegisteredERPS === false) {
      consultRegisteredIntegrations().then((response) => {
        const mappedData = response.data.map((item) => ({
          title: item.integration_title,
          icon: item.integration_logo,
          onClick: () => { },
          pago: () => { }
        }));

        setRegisteredERPS(mappedData);
        setAlreadyFetchRegisteredERPS(true);
      });

    }
  }, [userInfo]);

  const fetchData = async () => {

    try {

      const resultJson = await GetListagens();

      let listagens = resultJson['data'].map((item) => {
        return {
          id: item['code'],
          title: item['title'],
          desc: truncateText(item['description'], 50),
          link: item['url'],
          type: item['type'],
          icon: item['type']
        }
      });

      setSheets(listagens);
      setAlreadyFetchSheets(true);

    } catch (error) {
      console.error("Erro ao obter dados da API:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }

  const handleDelete = async (item) => {
    try {

      const resultJson = await DeleteListagens(item.id);

      if ((resultJson['message'] || resultJson['status']) === 'success') {
        setOpenModalDelete(false);
        fetchData();
      }

    } catch (error) {
      console.error("Erro ao obter dados da API:", error);
    }
  }

  const handlePageAdd = () => {
    navigate("/listagens/adicionar");
  };

  return (
    <Fragment>
      <Box width={"100%"} height={"100vh"}>
        <HeaderPage title="Planilhas" />
        {
          (loading === false && sheets.length === 0 && alreadyFetchSheets === true) ? (
            <Box display={"flex"} sx={{ justifyContent: "center", alignItems: "center", width: "100%", height: "90%" }}>
              <Box sx={{ width: { xs: "80%", sm: "auto" } }}>
                <Box component="img" src={EmptyTemplate} alt="Você não tem modelos" sx={{ width: { xs: "247px", sm: "494px" }, height: { xs: "165px", sm: "330px" } }} />
                <Box display={"flex"} sx={{ flexDirection: "column", gap: "10px", justifyContent: "center", textAlign: "center" }}>
                  <Titles bold type={"H3"} children={"Parece que você não tem planilhas :("} color={"#8033F4"} />
                  <Titles type={"P1"} children={"Importe uma agora mesmo, é fácil e rápido"} />

                  <Button
                    variant='contained'
                    style={{ color: '#fff', width: '100%', padding: '10px', marginTop: "10px" }}
                    onClick={() => handlePageAdd()}
                  >
                    Importar Listagem
                  </Button>
                </Box>
              </Box>
            </Box>
          ) : (
            <SheetsTable
              tableName={'Listagens'}
              loading={loading}
              data={sheets}
              columns={[
                {
                  field: 'icon',
                  headerName: '',
                  width: 80,
                  renderCell: (params) => <StatusIcon status={params.value} color={themeColors.purple500} />,
                  sortable: false,
                },
                {
                  field: 'title',
                  headerName: 'Título',
                  flex: 1,
                },
                {
                  field: 'desc',
                  headerName: 'Descrição',
                  flex: 1.5,
                },
                {
                  field: 'type',
                  headerName: 'Tipo',
                  flex: 1,
                  renderCell: (params) => <StatusLabel status={params.value} usingOnTable />
                }
              ]}
              actions={[
                {
                  icon: <GridViewStreamIcon style={{ color: ThemeColors.gray30, fontSize: '14px' }}
                  />, tooltip: 'Visualizar', action: (item) => window.open(item.link, '_blank'), isVisible: (item) => item && item.type === 'Google planilhas'
                },
                {
                  icon: <DeleteIcon style={{ color: ThemeColors.gray30, fontSize: '14px' }}
                  />, tooltip: 'Excluir', action: (item) => (setOpenModalDelete(true), setSelectedList(item)), isVisible: (item) => item
                }
              ]}
              redirect={() => handlePageAdd()}
              redirectText={"Adicionar Listagem"}
            />
          )
        }
      </Box>
      <ModalR
        cancelText={"Mudei de ideia"}
        color={ThemeColors.purple500}
        confirmText={"Sim, desejo excluir"}
        subTitle={"Esta ação não poderá ser desfeita"}
        isOpen={openModalDelete}
        onClose={() => setOpenModalDelete(false)}
        onConfirm={selectedList ? () => handleDelete(selectedList) : null}
        title={"Tem certeza que deseja excluir?"}
        emoji={"emoji10"}
        iconColor={ThemeColors.purple400}
      />
    </Fragment>
  );
}

export default Sheets;